import React, { forwardRef, useState } from "react";
import Icon from "../Icon";
import { Spinner } from "../primitives";
import { MAX_CLUB_GALLERY_PHOTOS, getClubGalleryPhotoCount, getVisibleStagedPhotoAssets } from "../../../../components/admin/editBioHelpers";

/**
 * Club photo gallery editor: saved URLs + this session's staged photos in one grid, a "+" tile,
 * and drag-and-drop of image files onto the grid (mockup "Drag photos straight onto this area").
 */
const GalleryEditor = forwardRef(function GalleryEditor({ saved, staged, uploading, onRemoveSaved, onRemoveStaged, onPick, onDropFiles }, ref) {
  const [over, setOver] = useState(false);
  const visibleStaged = getVisibleStagedPhotoAssets(staged);
  const count = getClubGalleryPhotoCount(saved, staged);
  const full = count >= MAX_CLUB_GALLERY_PHOTOS;

  return (
    <div className="field" ref={ref}>
      <span className="row" style={{ justifyContent: "space-between" }}>
        <span>Gallery</span>
        <span className="meta tnum">{count}/{MAX_CLUB_GALLERY_PHOTOS}</span>
      </span>
      <div
        className={`mg-grid${over ? " over" : ""}`}
        onDragOver={(e) => { if (e.dataTransfer?.types?.includes("Files")) { e.preventDefault(); setOver(true); } }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          if (e.dataTransfer?.files?.length) onDropFiles(e.dataTransfer.files);
        }}
      >
        {saved.map((uri, i) => (
          <div key={`s-${uri}-${i}`} className="mg-tile">
            <img src={uri} alt="" loading="lazy" />
            <button type="button" className="mg-x" aria-label="Remove photo" data-testid={`manage.bio.photo.${i}.remove`} onClick={() => onRemoveSaved(i)}><Icon name="x" size={14} /></button>
          </div>
        ))}
        {visibleStaged.map((a) => (
          <div key={a.assetIdentity} className="mg-tile">
            <img src={a.uploadUri} alt="" />
            {a.status === "failed" && <span className="mg-badge">Retry on Save</span>}
            {a.status === "selected" && <span className="mg-badge"><Spinner label="Uploading" /></span>}
            <button type="button" className="mg-x" aria-label="Remove staged photo" data-testid={`manage.bio.stagedPhoto.${a.assetIdentity}.remove`} disabled={uploading && a.status === "selected"} onClick={() => onRemoveStaged(a.assetIdentity)}><Icon name="x" size={14} /></button>
          </div>
        ))}
        <button type="button" className="mg-add" aria-label="Add photos" data-testid="manage.bio.addPhotos" disabled={uploading || full} onClick={onPick}>
          {uploading ? <Spinner label="Uploading" /> : <Icon name="plus" size={22} />}
        </button>
      </div>
      <span className="meta">
        {full ? "Gallery full. Remove a photo to add another." : `Drag photos straight onto this area to add them. Up to ${MAX_CLUB_GALLERY_PHOTOS} photos.`}
      </span>
    </div>
  );
});

export default GalleryEditor;
